import { useState } from "react";
import { BeatLoader } from "react-spinners";

function BtnSpinner() {
  const [loading, setLoading] = useState(true);
  const [color] = useState("white");

  return (
    <div className="sweet-loading">
      <BeatLoader color={color} loading={loading} size={15} />
    </div>
  );
}

export default BtnSpinner;
